export const genericLoadingMessages = [
  'search.generatingReport.loading.generic.searching',
  'search.generatingReport.loading.generic.scanning',
  'search.generatingReport.loading.generic.gathering',
  'search.generatingReport.loading.generic.analyzing',
  'search.generatingReport.loading.generic.processing',
  'search.generatingReport.loading.generic.identifying',
  'search.generatingReport.loading.generic.evaluating',
  'search.generatingReport.loading.generic.reviewing',
  'search.generatingReport.loading.generic.detecting',
  'search.generatingReport.loading.generic.combining',
  'search.generatingReport.loading.generic.verifying',
  'search.generatingReport.loading.generic.crossReferencing',
  'search.generatingReport.loading.generic.processingInputs',
  'search.generatingReport.loading.generic.refining',
]

export const scrapingSocialMediaMessages = [
  'search.generatingReport.loading.scraping.analyzing',
  'search.generatingReport.loading.scraping.analyzing',
  'search.generatingReport.loading.scraping.scanning',
  'search.generatingReport.loading.scraping.scanning',
  'search.generatingReport.loading.scraping.processing',
  'search.generatingReport.loading.scraping.processing',
  'search.generatingReport.loading.scraping.examining',
  'search.generatingReport.loading.scraping.examining',
  'search.generatingReport.loading.scraping.checking',
  'search.generatingReport.loading.scraping.checking',
  'search.generatingReport.loading.scraping.exploring',
  'search.generatingReport.loading.scraping.exploring',
]

export const analyzingMessages = [
  'search.generatingReport.loading.analyzing.collecting',
  'search.generatingReport.loading.analyzing.scanning',
  'search.generatingReport.loading.analyzing.evaluating',
  'search.generatingReport.loading.analyzing.processing',
  'search.generatingReport.loading.analyzing.uncovering',
  'search.generatingReport.loading.analyzing.mapping',
  'search.generatingReport.loading.analyzing.studying',
  'search.generatingReport.loading.analyzing.highlighting',
  'search.generatingReport.loading.analyzing.exploring',
  'search.generatingReport.loading.analyzing.reviewing',
  'search.generatingReport.loading.analyzing.examining',
  'search.generatingReport.loading.analyzing.focusing',
  'search.generatingReport.loading.analyzing.breaking',
]
